import { IProjectDTO } from '@/modules/projects/dtos/project.dto';
import { IProject } from '@/modules/projects/entities/project.entity';

export class ProjectMapper {
  public static toPresentation(project: IProjectDTO): IProject {
    return {
      id: project.id,
      name: project.nome,
      status: project.status,
      createdAt: project.createdAt,
      updatedAt: project.updatedAt,
      thumbnail: project.thumbnail,
      requested: project.solicitado,
      description: project.descricao,
      presignedUrl: project.presignedUrl,
    };
  }

  public static toDTO(project: IProject): IProjectDTO {
    return {
      id: project.id,
      nome: project.name,
      status: project.status,
      createdAt: project.createdAt,
      updatedAt: project.updatedAt,
      thumbnail: project.thumbnail,
      solicitado: project.requested,
      descricao: project.description,
      presignedUrl: project.presignedUrl,
    };
  }
}
